import { useEffect } from 'react';
import { useUser } from '../../contexts/user';
import { useCart } from '../../contexts/cart';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SpinnerIcon from '../../assets/spinner3.svg';
import log from '../../utils/logger';
 
const ADMIN_PANEL_ORIGIN = process.env.REACT_APP_ADMIN_PANEL_ORIGIN;

const AdminImpersonate = () => {
  const { login, setAdminImpersonate } = useUser();
  const { setCart, setCartId } = useCart();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (window.opener && ADMIN_PANEL_ORIGIN) {
      window.opener.postMessage('ready-for-auth', ADMIN_PANEL_ORIGIN);
    }

    const handleMessage = (event) => {
      try {
        if (!ADMIN_PANEL_ORIGIN || event.origin !== ADMIN_PANEL_ORIGIN) { return; }

        const { adminAccessToken, user, userCart, cartId } = event.data;

        if (!adminAccessToken || !user) { return; }

        setAdminImpersonate(adminAccessToken);

        login(user, null); // idToken is null since we are using admin token
        setCart(userCart || []);
        setCartId(cartId || null);

        const userLang = user.language;
        const defaultLang = 'en';

        if (typeof userLang === 'string' && userLang.length === 2) {
          i18n.changeLanguage(userLang).catch(err => {
            log.warn('Failed to change language:', err);
          });
        } else {
          i18n.changeLanguage(defaultLang);
        }

        if (location.pathname === '/home') {
          window.location.reload();
        } else {
          navigate('/home');
        }
      } catch (err) {
        log.error('Error handling admin impersonation message:', err);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [login, setCart, setCartId, i18n, navigate, setAdminImpersonate]);

  return <div className="flex items-center justify-center h-dvh">
    <img
      src={SpinnerIcon}
      alt="Loading..."
      className="h-10 w-10 animate-spin"
    />
  </div>;
};

export default AdminImpersonate;
